import { request } from "@/request";

//登录
export function fetchLogin(data) {
  return request({
    url: `/login`,
    method: "post",
    headers: {},
    data
  });
}

// 获取用户信息
export function fetchLoginInfo(params) {
  return request({
    url: `/me`,
    headers: {},
    params
  });
}

// 发送验证码
export function fetchSendSms(data) {
  return request({
    url: `/send-sms`,
    method: "post",
    headers: {},
    data
  });
}

// 忘记密码进行重置
export function fetchForgetPwd(data) {
  return request({
    url: `/update-password`,
    method: "post",
    headers: {},
    data
  });
}
